import React from 'react';
import { useDispatch } from 'react-redux';

import { clearAll, createMessage, exportMessages, getIdeasMessages } from '../../../redux/id8/id8Actions';
import CommonMessagesOutput from '../common-messages-output/CommonMessagesOutput';
import MessageFilters from './message-filters/MessageFilters';
import MessagesGeneratingStatusController from '../generating-status-controller/MessagesGeneratingStatusController';

import scss from '../../Id8.module.scss';

function IdeasTab({ bindAction, isShowGenerationForm }) {
  const dispatch = useDispatch();

  const handleSearchIdeasMessages = ({ id }) => {
    dispatch(getIdeasMessages({ id }));
  };

  return (
    <div className={scss.outputWrapper}>
      <MessageFilters onClearAll={clearAll} onExportMessages={exportMessages} onCreateMessage={createMessage} />

      <CommonMessagesOutput
        bindAction={bindAction}
        searchFunction={handleSearchIdeasMessages}
        isShowGenerationForm={isShowGenerationForm}
      />

      <MessagesGeneratingStatusController />
    </div>
  );
}

export default IdeasTab;
